module.exports = __webpack_public_path__ + "img/6.1-Pivot-Fruit.d307af13.png";